import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faFacebookF, faInstagram, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

import { emersonRoutes } from "@clinic/emerson/data/emersonRoutes";

export interface SiteLink {
  link: string;
  label: string;
}

interface SocialMediaLink extends SiteLink {
  icon: IconDefinition;
}

export const socialLinks: SocialMediaLink[] = [
  {
    link: "https://www.linkedin.com/company/emerson-ecologics/",
    label: "LinkedIn",
    icon: faLinkedinIn,
  },
  {
    link: "https://www.facebook.com/emersonecologics",
    label: "Facebook",
    icon: faFacebookF,
  },
  {
    link: "https://www.instagram.com/emerson_ecologics/",
    label: "Instagram",
    icon: faInstagram,
  },
];

export const siteLinkGroup1: SiteLink[] = [
  {
    link: "https://www.emersonecologics.com/blog/post/about-us",
    label: "About Us",
  },
  {
    link: "https://www.emersonecologics.com/blog/",
    label: "Blog",
  },
  {
    link: emersonRoutes.brands,
    label: "Brands",
  },
  {
    link: "https://go.emersonecologics.com/specials",
    label: "Specials",
  },
];

export const siteLinkGroup2: SiteLink[] = [
  {
    link: "https://fullscript.com/careers",
    label: "Join Our Team",
  },
  {
    link: "https://help.emersonecologics.com/",
    label: "Help Center",
  },
  {
    link: "https://help.emersonecologics.com/articles/contact-support/",
    label: "Contact Us",
  },
];

export const siteLinkGroup3: SiteLink[] = [
  {
    link: emersonRoutes.termsOfSale,
    label: "Terms of Sale",
  },
  {
    link: emersonRoutes.privacyPolicy,
    label: "Privacy Policy",
  },
];
